var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kpi-badge",class:`kpi-badge-${_vm.type}`},[(_vm.showBadgeIcon)?_c('div',{staticClass:"kpi-badge-icon"},[_c('Icon',{attrs:{"name":`kpi_badge_${_vm.type}_icon`}})],1):_vm._e(),_c('div',{staticClass:"kpi-badge-text"},[_c('span',{staticClass:"text-capitalize"},[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }